/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HousewareSprayIcon16Light } from './HousewareSprayIcon16Light';
import { HousewareSprayIcon16Regular } from './HousewareSprayIcon16Regular';
import { HousewareSprayIcon16Solid } from './HousewareSprayIcon16Solid';
import { HousewareSprayIcon20Light } from './HousewareSprayIcon20Light';
import { HousewareSprayIcon20Regular } from './HousewareSprayIcon20Regular';
import { HousewareSprayIcon20Solid } from './HousewareSprayIcon20Solid';
import { HousewareSprayIcon24Regular } from './HousewareSprayIcon24Regular';
import { HousewareSprayIcon24Solid } from './HousewareSprayIcon24Solid';
import { HousewareSprayIcon32Regular } from './HousewareSprayIcon32Regular';
import { HousewareSprayIcon64Regular } from './HousewareSprayIcon64Regular';
var sizes = {
    16: {
        light: HousewareSprayIcon16Light,
        regular: HousewareSprayIcon16Regular,
        solid: HousewareSprayIcon16Solid,
    },
    20: {
        light: HousewareSprayIcon20Light,
        regular: HousewareSprayIcon20Regular,
        solid: HousewareSprayIcon20Solid,
    },
    24: {
        regular: HousewareSprayIcon24Regular,
        solid: HousewareSprayIcon24Solid,
    },
    32: {
        regular: HousewareSprayIcon32Regular,
    },
    64: {
        regular: HousewareSprayIcon64Regular,
    },
};
export var HousewareSprayIcon = forwardRef('HousewareSprayIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
